import React, { memo, useState, useCallback } from "react";
import Button from "@material-ui/core/Button";
import type { FC } from "react";
import { Dialog } from "./Dialog";
import { useStyles } from "./SaveAsBulkExportStateButton.styles";
import { useSaveAsSettingsButton } from "./SaveAsBulkExportStateButton.state";
import { useExportNameValidator } from "../../../../shared/hooks/useExportNameValidator";

export const SaveAsBulkExportStateButton: FC = memo(() => {
  const classes = useStyles();
  const settingsButtonState = useSaveAsSettingsButton();
  const saveExportSettings = settingsButtonState?.saveExportSettings;

  const [openDialog, setOpenDialog] = useState(false);
  const [saved, setSaved] = useState(false);
  const [name, setName] = useState<string>("");
  const [valid, error] = useExportNameValidator(name);
  const [message, setMessage] = useState<string>("");
  const handleCloseDialog = useCallback(() => setOpenDialog(false), [setOpenDialog]);
  const handleSaveBulkExportState = useCallback(() => {
    if (valid && saveExportSettings) {
      saveExportSettings(name);
      setSaved(true);
      setMessage("")
    }else{
      setMessage(error[0].defaultMessage as string)
    }
  }, [setOpenDialog, saveExportSettings, name, valid]);
  const handleClick = useCallback(() => {
    setName("");
    setOpenDialog(true);
    setSaved(false);
    setMessage("")
  }, [setOpenDialog, name, saved]);

  return (
    <>
      <Dialog
        open={openDialog}
        onCancel={handleCloseDialog}
        onApply={handleSaveBulkExportState}
        name={name}
        setName={setName}
        saved={saved}
        errorMessage={message}
        setMessage={setMessage}
      />
      <Button color="primary" variant="contained" onClick={handleClick} classes={classes}>
        Save as
      </Button>
    </>
  );
});
